<template>
  <section class="modal adduser new_adduser" v-if="getInvite" @click="changeState({element: 'invite_new', val: false})">
    <div class="modal-wrap">
    <div class="modal-block" @click.prevent.stop>
      <!-- Поиск -->
        <div class="timeline-string">
      <div class="search">
        <div class="search-input">
          <img class="search__icon" src="@/assets/images/icons/icon_search.svg">
          <input type="search" placeholder="Ищи ветра в поле" v-model="search" @keyup.enter="searchByTitle">
        </div>
      </div>

    <!-- Фильтры -->
      <div class="timeline-buttons">
        <div class="map-button map-button_rainbow" @click="changeState({element: 'sports'})" v-if="!friends">
          <p>Категории</p>
        </div>
        <div class="button" @click="myFriends()" :class="{active: friends}">Мои друзья</div>
      </div>
      </div>
      <Sports :sports="getActiveSports" v-if="!friends"/>
      <div class="modal-body" v-if="users && users.users.length > 0 && getNewInvites">
        <div class="people" @click="addUser(user)" v-for="user in users.users" :key="user.id" :class="{cover: user.cover ? 'cover' : '', active: hasInvited(user)} " :style="{backgroundImage: 'url('+ user.cover +')'}">
            <div class="chouse-check">
              <img src="@/assets/images/icon_check-user.svg" width="16px">
            </div>
            <div class="people-avatar" :style="{backgroundImage: 'url('+ user.avatar +')', backgroundPosition: user.avatar_position}">
                <div class="people-rate" v-if="user.rate" :title="user.rate.title" :class="user.rate.color">
                    <img :src="require(`@/assets/images/defaults/icon_${user.rate.image}.png`)">
                </div>
            </div>
            <p class="people__name">{{ user.firstname + ' ' + user.lastname}}</p>
            <p class="people__status">{{ user.shortdesc }}</p>
            <div class="people-category" v-if="user.sports">
                <div v-for="cat in shortSports(user)" :key="cat.id" class="people-category__item" :class="cat.color">{{cat.ru}}</div>
                <div class="people-category__item dark" v-if="user.sports.length > 5">и еще {{user.sports.length - 5}}</div>
            </div>
        </div>
      </div>
      <div class="modal-body" v-else>
        <p class="modal-nothing">Ничего не найдено 💩</p>
      </div>
    </div>
    <div class="chousen-counter" v-if="getNewInvites.length > 0" @click="sendInvite()">
      <p>Пригласить {{getNewInvites.length}} людей</p>
    </div>
    </div>
  </section>
</template>
<script>
import Sports from '@/components/Filters/Sports'

export default {
  name: "ModalInvite",
  data: () => {
    return {
      search: null,
      users: null,
      invited: [],
      friends: false
    };
  },
  components: {
    Sports
  },
  computed: {
      getInvite() {
        return this.$store.getters.invite_new
      },
      getActiveSports () {
        return this.$store.getters.getActiveSports
      },
      getUser () {
        return this.$store.getters.getAuthUser
      },
      getNewInvites() {
        return this.$store.getters.getNewInvites
      }
      
  },
  methods: {
    async loadData() {
      let type = this.friends ? 'friends' : '';
      let data = {sports: this.getActiveSports, search: this.search, type: type, user: this.getUser.id, page: 0};
      this.users = this.friends ?  await this.$store.dispatch('getFriends', data) : await this.$store.dispatch('getUsers', data);
    },
    shortSports(user) {
      return user.sports.slice(0, 5)
    },
    myFriends () {
      this.friends = !this.friends
      this.loadData()
    },
    changeState (element) {
        this.$store.dispatch('changeState', element)
    },
    hasInvited (user){
      return this.getNewInvites.find(item => user.id === item.id) ? true : false
    },
    addUser (user) {
      this.$store.dispatch('changeInviteNew', user)
    },
    async sendInvite() {
      this.changeState({element: 'invite', val: false})
    },
    searchByTitle () {
      this.search && this.search.length > 2 ? '' : this.search = null
      this.loadData()
    }
  },
  watch: {
    getActiveSports () {
      this.loadData('sports')
    }
  },
  mounted () {
    this.loadData()
  }
};
</script>